import { filterMode } from '../../common/filter-mode';

require('./catalog-node.component.scss');

/*@ngInject*/
class CatalogNodeController {
  constructor(
    $scope,
    $rootScope,
    CurrentFilterService,
    PermissionService,
    RouterService,
    FilterResource,
    FilterEditorService,
    FilterCardEditorModalService,
    FiltersService,
    CurrentModelService,
    $location,
    $q,
  ) {
    this.$rootScope = $rootScope;
    this.CurrentFilterService = CurrentFilterService;
    this.router = RouterService;
    this.FilterResource = FilterResource;
    this.FilterEditorService = FilterEditorService;
    this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.CurrentModelService = CurrentModelService;
    this.FiltersService = FiltersService;
    this.permission = PermissionService;
    this.$location = $location;
    this.$q = $q;
  }

  get isNodeOpen() {
    return this.filter.isNodeOpen;
  }

  set isNodeOpen(value) {
    this.filter.isNodeOpen = value;
  }

  get currentFilter() {
    return this.CurrentFilterService.filter;
  }

  setFilter() {
    if (this.filter.isPolitic() && this.filter.content_type !== 'corpusprocessfilter') {
      this.editFilter();
      return;
    }

    this.router.selectFilter(this.filter.id);

    const resetCount = true;
    if (this.filter.facts_count && resetCount) {
      this.FilterResource.save(this.filter)
        .then(() => {
          this.filter.facts_count = 0;
        })
        .catch(error => {
          console.error(!error);
        });
    }

    this.openNode();
  }

  openNode() {
    this.isNodeOpen = true;
  }

  editFilter() {
    return this.FilterEditorService.editModal(
      {
        filter      : this.filter,
        asNew       : false,
        selectFilter: true,
      },
    );
  }

  toggleNode() {
    this.isNodeOpen = !this.isNodeOpen;
  }

  isActive() {
    return this.currentFilter.id == this.filter.id;
  }

  get filterIcon() {
    return filterMode[this.filter.mode].icon;
  }
}

export const CatalogNodeComponent = function () {
  return {
    template        : require('./catalog-node.component.html'),
    replace         : true,
    bindToController: {
      filter: '<',
    },
    controller      : CatalogNodeController,
    controllerAs    : '$ctrl',
  };
};



// WEBPACK FOOTER //
// ./src/filter/catalog/catalog-node.component.js